// Module
var code = "<div class=\"logo\"> <cSvg height=\"21\" :href=\"`#${brand}-logo-${design}`\" :title=\"t('logo_brand')\" width=\"67\"/> <span :class=\"[`logo_headline -${design}`, { '-separator': separator }]\">{{ headline }}</span> </div> ";
// Exports
export default code;